import type { Action } from 'redux';
import type { ThunkAction } from 'redux-thunk';

import {
  OrderErrorType,
  setCurrentOrder,
  setCurrentOrderError,
  resetCurrentOrder as resetCurrentOrderAction,
} from '../currentOrder';
import { State } from '../types';
import { createOrder, getOrder } from '@wetransfer/transfer/api/orders';
import { setCurrentOrderAccessToken } from '@wetransfer/transfer/helper/paidTransfers';
import NotificationActions from '@wetransfer/transfer/store/action/notification';
import Pending from '@wetransfer/transfer/store/action/pending';

export const loadCurrentOrder =
  (authToken: string): ThunkAction<Promise<void>, State, null, Action> =>
  async (dispatch) => {
    const pendingId = 'getCurrentOrder';
    dispatch(Pending.setPending(pendingId));

    try {
      const response = await getOrder(authToken);
      dispatch(setCurrentOrder(response.body));
      dispatch(Pending.resetPending(pendingId));
    } catch (error) {
      dispatch(
        setCurrentOrderError(
          error?.status === 401
            ? error?.body?.message?.includes(OrderErrorType.ExpiredToken)
              ? OrderErrorType.ExpiredToken
              : OrderErrorType.UnrecognizedDevice
            : OrderErrorType.Unknown
        )
      );
    }
  };

export const resetCurrentOrder =
  (): ThunkAction<Promise<void>, State, null, Action> => async (dispatch) => {
    dispatch(resetCurrentOrderAction());
  };

export const createCurrentOrder =
  (transferId: string): ThunkAction<Promise<void>, State, null, Action> =>
  async (dispatch) => {
    const pendingId = 'createCurrentOrder';
    dispatch(Pending.setPending(pendingId));

    try {
      const response = await createOrder(transferId);

      if (response.ok) {
        setCurrentOrderAccessToken(transferId, response.body.access_token);
        setTimeout(
          () => (window.location.href = response.body.checkout_url),
          1
        );

        return;
      }
      dispatch(Pending.resetPending(pendingId));
    } catch {
      dispatch(
        NotificationActions.setNotification(
          'notification',
          'something_went_wrong'
        )
      );
    }
  };
